export { TurnosFinalizadosTab } from "./TurnosFinalizadosTab";

